<script lang="ts">
import SICCodesAutocompleteInput from './SICCodesAutocompleteInput.vue';
import { Label } from 'reka-ui';
import DatePicker from './DatePicker.vue';
import { type DateValue } from '@internationalized/date';

export default {
  name: 'Playground',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import ManagedDateRange from '@/components/ManagedDateRange.vue';

const sicCode = ref<string>('');
const startDate = ref<Date>(new Date());
const endDate = ref<Date>(new Date());


const datePickerDate = ref<DateValue>();
</script>

<template>
  <div class="tw:flex tw:h-full tw:w-1/2 tw:flex-col tw:items-stretch tw:gap-8 tw:p-4">
    <div>
      <div>SIC Codes Autocomplete</div>
      <SICCodesAutocompleteInput v-model="sicCode" />
    </div>
    <div>
      
    </div>
    

    <div class="tw:mt-4">
      <managed-date-range :initial-start-date="startDate" :initial-end-date="endDate" />
    </div>

    <div class="tw:flex tw:flex-col tw:gap-2">
      <Label class="tw:text-sm" for="date-field">Date Picker</Label>
      <DatePicker v-model="datePickerDate"/>
    </div>
  </div>
</template>
